import {
  customType,
  extend,
  params,
  string,
  bool,
  number,
  shape,
  arrayOf,
} from '@thd-nucleus/data-sources';
import { RetailMediaCarouselPod } from './RetailMediaCarouselPod';

export const dataModel = extend({
  plaModel: params({
    breadCrumbs: arrayOf(customType('BreadCrumbInput').shape({
      browseUrl: string(),
      label: string()
    })),
    categorySourceId: string(),
    channel: string(),
    customer: customType('Customer').shape({
      mcVisId: number(),
      customerType: string(),
      userId: string(),
      svocId: string(),
    }),
    debug: bool(),
    itemId: string(),
    itemIds: arrayOf(string()),
    keyword: string(),
    nValue: string(),
    requestedAdCount: number(),
    schema: string(),
    storeId: string(),
    zipCode: string(),
    plaLocation: string(),
    adBlocker: string(),
    carouselType: string(),
    isBrandPricingPolicyCompliant: bool(),
  }).shape({
    products: arrayOf(
      shape(RetailMediaCarouselPod.dataModel.product),
    ),
    sponsoredReport: shape({
      numberOfSponsoredProducts: number(),
      numberOfMissingProductInformationProducts: number(),
      numberOfNonAvailableProducts: number(),
    }),
    carouselMetadata: shape({
      title: string(),
    }),
    analytic: shape({
      isAbTest: bool(),
    }),
  }),
});
